import { RadioGroup } from '@zvuk-b2b/ui-kit';
import { IVideoStream } from 'application/pages/PointsGroupsPage/types';
import React from 'react';
import VideoStreamPreviewItem from '../VideoStreamInfo/VideoStreamPreviewItem';
import styles from './index.module.scss';

interface IChooseVideoStreamProps {
  videoStreams?: IVideoStream[];
  masterVideoStreamId?: string | number;
  setVideoStreamId: (id: string | number) => void;
}

export const ChooseVideoStream: React.FC<IChooseVideoStreamProps> = ({
  videoStreams,
  masterVideoStreamId,
  setVideoStreamId,
}) => (
  <RadioGroup
    value={masterVideoStreamId !== undefined ? String(masterVideoStreamId) : null}
    onValueChange={(value) => {
      const stream = videoStreams?.find((it) => String(it.id) === value);

      if (stream) setVideoStreamId(stream.id);
    }}>
    {videoStreams?.map((it) => (
      <RadioGroup.Item
        key={it.id}
        value={String(it.id)}
        labelClassName={styles.label}
        stretch
        data-testid={`video_stream_${it.id}`}>
        <VideoStreamPreviewItem stream={it} />
      </RadioGroup.Item>
    ))}
  </RadioGroup>
);
